// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaimedToast-cls1_1p2","cls2":"PaperClaimedToast-cls2_KsA PaperClaimedToast-cls1_1p2"};